module.exports = __webpack_public_path__ + "static/img/decidoc-03.44186fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/decidoc-03.png
// module id = 76
// module chunks = 0